import { useState } from 'react'

import { UsersWebPageUser } from '../../../types'

export const useResetPassword = () => {
  const [userToResetPassword, setUserToResetPassword] = useState<UsersWebPageUser | null>(null)
  const closeResetPasswordDialog = () => setUserToResetPassword(null)

  return {
    userToResetPassword,
    closeResetPasswordDialog,
    onResetPassword: setUserToResetPassword
  }
}
